import { cn } from "@/lib/utils";

interface FormBodyProps {
  children: React.ReactNode;
  className?: string;
}

export function FormBody({ children, className }: FormBodyProps) {
  return (
    <div
      className={cn(
        "space-y-6 px-6 py-6 sm:space-y-0 sm:divide-y sm:divide-border sm:py-0",
        className,
      )}
    >
      {children}
    </div>
  );
}
